module.exports = __webpack_public_path__ + "img/neowalls_logo_extended.c4c7113a.svg";